import * as React from 'react'
import { useStyles } from '../CaseDiagnosisStyles'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'
import NoteIcon from '@mui/icons-material/Note'

export default function GrossDescription({ messages }) {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const classes = useStyles()
  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  return (
    <div>
      <NoteIcon style={{ color: '#0d688d', float: 'left', height: '20px' }} />
      <Typography
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        className={classes.grossDescription}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        Gross Description
      </Typography>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {messages &&
          messages.length > 0 &&
          messages.map((message, index) => {
            return (
              <Typography
                sx={{ p: 1, backgroundColor: 'rgba(146, 187, 204, 0.55)', width: '450px', fontSize: '14px' }}
                key={index}
              >
                {message.label}:{message.value}
              </Typography>
            )
          })}
      </Popover>
    </div>
  )
}
